import { render, staticRenderFns } from "./SelectableBodyStyleInputV2.vue?vue&type=template&id=77f3dc46&"
import script from "./SelectableBodyStyleInputV2.vue?vue&type=script&lang=js&"
export * from "./SelectableBodyStyleInputV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports